export default __webpack_public_path__ + "static/media/profile-3.70c6246e.webp";